import React from 'react'
import {
	Box,
	Typography,
	Table,
	TableBody,
	TableContainer,
	TableHead,
	TableRow,
	Chip,
	IconButton,
} from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import { NonProgressibleWorkType } from '../../../../../../types/Work/NonProgressible'
import { StyledTableCell } from '../../../../../core/StyledTableCell'
import SearchBar from '../../../../../core/SearchBar'

type NonProgressiblesTabProps = {
	nonProgressibleWorkTypes: NonProgressibleWorkType[]
	onAddTask: (taskId: number, path: string, activityType: 'nonProgressible') => void
	searchText: string
	handleSearchTextChange: (searchText: string) => void
}

const NonProgressiblesTab = ({
	nonProgressibleWorkTypes,
	onAddTask,
	searchText,
	handleSearchTextChange,
}: NonProgressiblesTabProps) => {

	const handleAddNonProgressible = (workType: NonProgressibleWorkType) => {
		if (workType.id !== null) {
			onAddTask(workType.id, workType.name, 'nonProgressible')
		}
	}

	return (
		<Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
			<SearchBar
				onChange={handleSearchTextChange}
				searchPlaceholder='Filter by name'
				showIncludeFilter={false}
				searchText={searchText}
			/>
			{nonProgressibleWorkTypes.length === 0 ? (
				<Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
					<Typography variant='body1'>No non-progressible work types found.</Typography>
				</Box>
			) : (
				<TableContainer sx={{ maxHeight: '100%', overflowY: 'auto' }}>
					<Table stickyHeader>
						<TableHead>
							<TableRow>
								<StyledTableCell />
								<StyledTableCell align='left'>Name</StyledTableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{nonProgressibleWorkTypes.map((workType) => (
								<TableRow key={workType.id} hover>
									<StyledTableCell sx={{ paddingRight: '0' }}>
										{workType.id !== null && (
											<Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
												<IconButton
													aria-label='add non-progressible'
													size='small'
													onClick={() => handleAddNonProgressible(workType)}
													color='primary'
												>
													<AddIcon />
												</IconButton>
											</Box>
										)}
									</StyledTableCell>
									<StyledTableCell align='left'>{workType.name}</StyledTableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
				</TableContainer>
			)}
		</Box>
	)
}

export default NonProgressiblesTab
